import React from "react";
import styled from "styled-components";

import CallIcon from "views/resources/icons/callIcon.svg";

const Icon = styled.img`
	margin-right: 6px;
	@media (min-width: 765px) {
		width: 16px;
	}
`;

const Container = styled.div`
	display: flex;
`;

const Text = styled.span`
	font-size: 13px;
	font-weight: 400;
	@media (min-width: 765px) {
		font-size: 14px;
	}
`;

const type = {
	mixed: `Presencial - Videollamada`,
	meet: `Videollamada`,
	face2face: `Presencial`,
};

export const AttentionTypeLabel = ({ attentionType, mobile }) => {
	return (
		<Container>
			<Icon src={CallIcon} />
			<Text>{attentionType ? type[attentionType] : type.face2face}</Text>
		</Container>
	);
};
